import { ComponentIds, Entity } from '@inter-ikea-core/core';
import { CoreApi, Product, ProductType } from '@inter-ikea-storageone/range';
import { BestaFrameLegsFeatureSystem } from '@inter-ikea-storageone/range-besta';

export const removeProducts = (entities: Entity[], coreApi: CoreApi, products: Product[]) => {
  if (entities && entities.length > 0) {
    const defaultLegProduct = products.find(p => p.type === ProductType.BESTA_DEFAULT_LEG);
    const legs: Entity[] = [];
    const entitiesToRemove = entities.filter(e => {
      if (defaultLegProduct && e.hasComponent(ComponentIds.LEG_COMPONENT_ID)) {
        legs.push(e);
        return false;
      }
      return true;
    });

    if (defaultLegProduct && legs.length > 0) {
      coreApi
        .getSystem<BestaFrameLegsFeatureSystem>('BestaFrameLegsFeatureSystem')
        ?.setSelectedLeg(defaultLegProduct.coreProductId, false);
    }

    entitiesToRemove.forEach(entity => {
      coreApi.entities.delete(entity);
    });
  }
};
